import React from "react";
import {View, StyleSheet} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import {getTranslation} from "../../helpers/getTranslation";

export default function PtTicketStatusIndicator(props:any) {

  const statusCode = props.statusCode;
  const statusText = getTranslation(`ticket.status.${statusCode}`) || props.statusText;

  const indicatorColor = () => {
    // console.log('the status code = ', statusCode);
    switch (statusCode) {
      case '1': { return styleVars.boschLightGray }
      case '2': {return styleVars.boschYellow}
      case '4': {return styleVars.boschYellow}
      case '5': {return styleVars.boschLightGreen}
      case '6': {return styleVars.boschLightGreen}
      case 'Z1': {return styleVars.boschRed}

      default: return styleVars.boschLightGray
    }
  }


  const styles = StyleSheet.create({
    ticketStatusIndicatorContainer: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    ticketStatusIndicator: {
      width: styleVars.rem(.75),
      height: styleVars.rem(.75),
      borderRadius: styleVars.rem(.375),
      backgroundColor: indicatorColor(),
    },
    ticketStatusIndicatorTextContainer: {
      paddingLeft: styleVars.rem(.5),
    },
    ticketStatusIndicatorText: {
      fontSize: styleVars.rem(.75),
      color: indicatorColor()
    }
  });


  return (
    <View style={[styles.ticketStatusIndicatorContainer]}>
      <View style={[styles.ticketStatusIndicator, indicatorColor]}></View>
      <View style={[styles.ticketStatusIndicatorTextContainer]}>
        <PtText style={[styles.ticketStatusIndicatorText]}>
          {statusText}
        </PtText>
      </View>
    </View>
  )
}
